/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import Tooltip from 'DesignSystem/Tooltip/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/WaitingRoom/Content/Content/Checkout/Appointments/Content/Appointment/Name/NameTooltip/Content"
  
}) {
let appointmentBookingPatientPersonValueData = fromData.useDataValue({ viewPath,
context: 'appointment_booking',
path: 'patient_person',
})
let globalUserPreferencesHipaaValueData = fromData.useDataValue({ viewPath,
context: 'global',
path: 'user.preferences.hipaa',
})
let aggregateData = fromAggregate.patientName(appointmentBookingPatientPersonValueData, globalUserPreferencesHipaaValueData)
let dtColorsNeutral800 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.800'
        })
  return (<React.Fragment
>
<Tooltip
  viewPath={`${viewPath}/Tooltip`}
 size="small"
 top={24}
 left={0}
 height="auto"
 backgroundColor={dtColorsNeutral800}
 whiteSpace="wrap"
 data="appointment_booking.patient_person"
 data="global.user.preferences.hipaa"
 aggregate="/Data/aggregate.js patientName"
 text={aggregateData}
/>
{children}
</React.Fragment>)
}